export const NODE_LABEL_PADDING = 8;
export const GHOST_STROKE_WIDTH_OFFSET = 8;
export const NODE_HEADER_PADDING = 20;

export const NODE_MINIMUM_HEIGHT = 2;

export const NODE_LABEL_SAFETY_MARGIN = 2;
